import { Fragment, useState, useContext } from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import FFPaper from '../../../components/shared/FFPaper';
import Title from '../../../components/shared/Title';
import EnrollmentListTopTools from '../../../components/dashboard/enrollment/EnrollmentListTopTools';
import EnrollmentListTable from '../../../components/dashboard/enrollment/EnrollmentListTable';
import EnrollmentListColumnHeader from '../../../components/dashboard/enrollment/EnrollmentListColumnHeader';
import AddEnrollmentModal from './AddEnrollment';
import { EnrollmentsContext } from '../../../context/enrollment-context';
import { useTranslation } from 'react-i18next';

export default function EnrollmentList() {
    const { data } = useContext(EnrollmentsContext);
    const [addEnrollment, openAddEnrollment] = useState(false);
    const { t } = useTranslation();

    const showAddEnrollmentModal = () => {
        openAddEnrollment(true);
    }

    const closeEnrollmentModal = () => {
        openAddEnrollment(false);
    }
    return (
        <Fragment>
            <Grid item={true} xs={12} sx={{ height: '100%' }}>

                <EnrollmentListTopTools openAddEnrollment={showAddEnrollmentModal} />
                <FFPaper
                    elevation={3}
                    sx={{
                        height: '100%',
                        paddingTop: '25px',
                        mt: 3,
                        pl: 0
                    }}
                >
                    <Box sx={{ pl: 4 }}>
                        <Title big={true} notooltip={true}>
                            {t('enroll_list')}
                        </Title>
                    </Box>

                    <Grid item={true} xs={12} sx={{ height: '100%', pt: 2 }}>

                        <EnrollmentListColumnHeader />

                        <EnrollmentListTable data={data?.enrollmentsPeopleEnrolled} />

                    </Grid>

                </FFPaper>
            </Grid>

            <AddEnrollmentModal open={addEnrollment} closeEnrollmentModal={closeEnrollmentModal} />
        </Fragment>
    )
}